export const twitterData = [
  {
    id: "51e0b3d9-4e64-453a-acd0-91e1e7f99bc5",
    name: "Taylor Swift on a world tour",
    number_of_posts: 603,
    percentage_fake: 20,
    spreaders: "COM 1",
    victims: "COM 4",
    ideology: "Commited conservatives",
  },
  {
    id: "73f23143-20c6-4000-b30a-c7cb54842c0c",
    name: "Rushi Sunak visits America",
    number_of_posts: 506,
    percentage_fake: 17,
    spreaders: "COM 2",
    victims: "COM 6",
    ideology: "Ambivalent Right",
  },
  {
    id: "1920872b-9c8f-4899-add0-040884451383",
    name: "Tom Cruise to star in a TV show",
    number_of_posts: 502,
    percentage_fake: 15,
    spreaders: "COM 4",
    victims: "COM 1",
    ideology: "Outsider Left",
  },
  {
    id: "69dbbf5c-289b-4032-88f8-2e19bf73643a",
    name: "Trump's visit to India",
    number_of_posts: 354,
    percentage_fake: 14,
    spreaders: "COM 1",
    victims: "COM 5",
    ideology: "Democratic mainstays",
  },
  {
    id: "6a71604f-8a4f-45a0-926e-676b6da00434",
    name: "X to change back to blue bird",
    number_of_posts: 1500,
    percentage_fake: 13.9,
    spreaders: "COM 8",
    victims: "COM 6",
    ideology: "Progressive Left",
  },
  {
    id: "db4fe93a-3eb6-4062-9efd-13822ed30868",
    name: "Selena Gomez donate whopping sum to Las Vegas",
    number_of_posts: 251,
    percentage_fake: 12.8,
    spreaders: "COM 11",
    victims: "COM 6",
    ideology: "Conservative",
  },
  {
    id: "a5f82537-41f6-40f6-bd10-12971fd463a6",
    name: "White House visited by Indian Man",
    number_of_posts: 457,
    percentage_fake: 12,
    spreaders: "COM 14",
    victims: "COM 3",
    ideology: "Progressive Left",
  },
  {
    id: "bfd8e23b-54d6-4a9c-b31b-e5b5b3db171c",
    name: "No Funding by US government ",
    number_of_posts: 326,
    percentage_fake: 11.8,
    spreaders: "COM 16",
    victims: "COM 7",
    ideology: "Progressive Left",
  },
  {
    id: "bfd8e23b-54d6-4a9c-b31b-e5b5b3db171c",
    name: "Kanye west fails to pay for child support",
    number_of_posts: 187,
    percentage_fake: 11.5,
    spreaders: "COM 18",
    victims: "COM 8",
    ideology: "Progressive Right",
  },
  {
    id: "626fbe56-f572-4d74-9a3e-b74155127471",
    name: "Special Cameo of Angelena Jolie in TV show friends",
    number_of_posts: 689,
    percentage_fake: 11,
    spreaders: ".COM 21",
    victims: "COM 3",
    ideology: "Progressive Right",
  },
  {
    id: "89634874-b616-44a0-95f7-9299467bf8d8",
    name: "Eminem new song is a huge flop",
    number_of_posts: 1000,
    percentage_fake: 10,
    spreaders: "COM8",
    victims: "COM 6",
    ideology: "Progressive Left",
  },
  {
    id: "a4a49607-09fb-4b85-a189-8e212afc2f1e",
    name: "Burger King increases tax on burgers",
    number_of_posts: 800,
    percentage_fake: 9,
    spreaders: "COM 9",
    victims: "COM 3",
    ideology: "Conservative",
  },
  {
    id: "50a1dfe7-d3be-4d9c-a911-6bc9b55b4cda",
    name: "10 year old kid gets a PHD",
    number_of_posts: 450,
    percentage_fake: 8.5,
    spreaders: "COM 12",
    victims: "COM 9",
    ideology: "Conservative",
  },
  {
    id: "e9069b2b-e0b0-48c6-b97a-dfcb5d781f81",
    name: "American Weather is most affected in 2023 by global warming ",
    number_of_posts: 550,
    percentage_fake: 8,
    spreaders: "COM 14",
    victims: "COM 11",
    ideology: "Progressive Left",
  },
  {
    id: "829d9333-1151-44f6-b8bc-08bd6efc1f93",
    name: "Zendaya and Tom Holland Breakup",
    number_of_posts: 300,
    percentage_fake: 6,
    spreaders: "COM 20",
    victims: "COM 11",
    ideology: "Conservative",
  },
];
